import '@trukt/configs/tailwind/base.css';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { DefaultErrorBoundary } from '@trukt/ui/DefaultErrorBoundary';
import { router } from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
  <DefaultErrorBoundary>
    <RouterProvider router={router} />
  </DefaultErrorBoundary>,
);
